import React, { useEffect, useState } from 'react';
import { Table, ListGroup, Button, Badge, Row, Col, Form, Spinner,Offcanvas } from 'react-bootstrap';
import { getInventory } from '../../services/Items/Inventory';
import ItemDetailsModal from '../../components/Items/ItemDetailsModal';
import ItemLogsModal from '../../components/Items/ItemLogsModal';
import { getCategories } from '../../services/Configs/ItemCategoriesService';
import { getLocations } from '../../services/Configs/LocationsService'; 
import { getStatuses } from '../../services/Other/GeneralQueries'; 
import { useReactTable, getCoreRowModel, flexRender, getPaginationRowModel, getSortedRowModel, getFilteredRowModel } from '@tanstack/react-table';

function Inventory() {
    
    const [categories, setCategories] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [locations, setLocations] = useState([]);
    const [qtyList, setQtyList] = useState(999999);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [selectedId, setSelectedId] = useState(0);
    const [selectedToken, setSelectedToken] = useState('');
    const [showDetails, setShowDetails] = useState(false);    
    const [showLogs, setShowLogs] = useState(false);    
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [show, setShow] = useState(false);
    const [pagination, setPagination] = useState({
        pageIndex: 0, //initial page index
        pageSize: 10, //default page size
      });
    const [sorting, setSorting] = useState([]);
    const [filtering, setFiltering] = useState('');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleShowDetails = (id, token) => {
        setSelectedId(id);
        setSelectedToken(token);
        setShowDetails(true);
    };

    const handleCheckboxChangeCategories = (id) => {
        setSelectedCategories((prevSelectedIds) =>
            prevSelectedIds.includes(id)
                ? prevSelectedIds.filter((selectedId) => selectedId !== id)
                : [...prevSelectedIds, id]
        );
    };
    const handleCheckboxChangeLocations = (id) => {
        setSelectedLocations((prevSelectedIds) =>
            prevSelectedIds.includes(id)
                ? prevSelectedIds.filter((selectedId) => selectedId !== id)
                : [...prevSelectedIds, id]
        );
    };

    const handleCheckboxChangeStatuses = (id) => {
        setSelectedStatuses((prevSelectedIds) =>
            prevSelectedIds.includes(id)
                ? prevSelectedIds.filter((selectedId) => selectedId !== id)
                : [...prevSelectedIds, id]
        );
    };
    
    const handleOpenModalLogs = (id) => {
        setSelectedId(id);
        setShowDetails(false);
        setShowLogs(true);
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined || value === '' || isNaN(value)) {
            return '-';
        }
        
        const number = parseFloat(value);
        
        if (isNaN(number)) {
            return '-';
        }
        
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number);
    };

    const calculateInventoryValue = (unitPrice, quantity) => {
        const price = parseFloat(unitPrice);
        const qty = parseFloat(quantity);
        
        // Si ambos son nulos o inválidos
        if (isNaN(price) && isNaN(qty)) {
            return '-';
        }
        
        // Si quantity es nulo pero unitPrice no
        if (isNaN(qty) && !isNaN(price)) {
            return formatCurrency(price);
        }
        
        // Si unitPrice es nulo pero quantity no
        if (isNaN(price) && !isNaN(qty)) {
            return '-';
        }
        
        // Si ambos tienen valor, multiplicar
        if (!isNaN(price) && !isNaN(qty)) {
            return formatCurrency(price * qty);
        }
        
        return '-';
    };
    
    const columns = [
        {
            header: 'Acciones',
            accessorKey: 'id',
            cell: ({ row }) => (
                <Button 
                    variant="primary" 
                    onClick={() => handleShowDetails(row.original.id, row.original.token)}
                >
                    ...
                </Button>
            )
        },
        {
            header: 'Nombre',
            accessorKey: 'name'
        },
        {
            header: 'Descripción',
            accessorKey: 'description'
        },
        {
            header: 'Categoría',
            accessorKey: 'categoryName'
        },
        {
            header: 'Subcategoría',
            accessorKey: 'subcategoryName'
        },
        {
            header: 'Precio unitario',
            accessorKey: 'unitPrice',
            cell: ({ row }) => formatCurrency(row.original.unitPrice)
        },
        {
            header: 'Cantidad en inventario',
            accessorKey: 'quantity'
        },
        {
            header: 'Valor en inventario',
            accessorKey: 'inventoryValue',
            cell: ({ row }) => calculateInventoryValue(row.original.unitPrice, row.original.quantity)
        },
        {
            header: 'Archivos',
            accessorKey: 'filesCount',
            cell: ({ row }) => {
                const count = row.original.filesCount || 0;
                return count > 0 ? (
                    <Badge bg="info">{count}</Badge>
                ) : (
                   <Badge bg="warning">0</Badge>
                );
            }
        },
        {
            header: 'Ubicación',
            accessorKey: 'locationName'
        },
        {
            header: 'Estatus',
            accessorKey: 'statusName'
        }
    ]
    useEffect(() => {
        getCategories().then(cList => {
            setCategories(cList);
            let categoryIds = cList.map(category => category.id);
            setSelectedCategories(categoryIds);
        }).finally(()=> {
            getLocations().then(lList => {
                setLocations(lList);
                let locationIds = lList.map(location => location.id);
                setSelectedLocations(locationIds);
            }).finally(()=> {
                getStatuses().then(sList => {
                    setStatuses(sList);
                    let statusIds = sList.map(status => status.id);
                    setSelectedStatuses(statusIds);
                })
            })
        })
        
    }, []);

    useEffect(() => {
        setLoading(true);
        getInventory(selectedCategories, selectedLocations, selectedStatuses, qtyList).then(getResult => {
            console.log("getResult", getResult)
            setData(getResult);
        }).finally(() => {
            setTimeout(() => {
                setLoading(false);
            }, 400);
           
        });
    }, [selectedCategories, selectedLocations, selectedStatuses,qtyList]);
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),       
        getFilteredRowModel: getFilteredRowModel(),
        state: {
          pagination,
          sorting,
          globalFilter: filtering
        },
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: setFiltering
      });
    const totalPages = Math.ceil(data.length / pagination.pageSize);

    return (
        <>

        <Offcanvas show={show} onHide={handleClose} placement="start">
            <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filtros <i class="bi bi-filter"></i></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                            <Row className='mt-1'>
                                <Col xl={12}>
                                    <h6>Categorías</h6>
                                    <ListGroup>
                                        {categories.map((checkbox) => (
                                            <ListGroup.Item key={checkbox.id}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`checkbox-${checkbox.id}`}
                                                    label={checkbox.name}
                                                    checked={selectedCategories.includes(checkbox.id)}
                                                    onChange={() => handleCheckboxChangeCategories(checkbox.id)}
                                                />
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col xl={12}>
                                    <h6>Ubicaciónes</h6>
                                    <ListGroup>
                                        {locations.map((checkbox) => (
                                            <ListGroup.Item key={checkbox.id}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`checkbox-${checkbox.id}`}
                                                    label={checkbox.name}
                                                    checked={selectedLocations.includes(checkbox.id)}
                                                    onChange={() => handleCheckboxChangeLocations(checkbox.id)}
                                                />
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col xl={12}>
                                <h6>Estatus</h6>
                                    <ListGroup>
                                        {statuses.map((checkbox) => (
                                            <ListGroup.Item key={checkbox.id}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`checkbox-${checkbox.id}`}
                                                    label={checkbox.name}
                                                    checked={selectedStatuses.includes(checkbox.id)}
                                                    onChange={() => handleCheckboxChangeStatuses(checkbox.id)}
                                                />
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </Col>
                            </Row>
                            
            </Offcanvas.Body>
      </Offcanvas>
      {
            loading ?
            <Row className='mt-5'>
                <Col className='text-center'>
                    <h3>Cargando</h3>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                </Col>
            </Row>
            :
            data.length === 0 ? (
                null
            ) : (
                <>
      <Row className="align-items-center my-3">
  {/* Botón de Filtros */}
  <Col xs={12} sm={4} md={1} className="mb-2 mb-md-0 text-start">
    <Button variant="outline-secondary" size="sm" onClick={handleShow} className="me-2">
      Filtros <i className="bi bi-filter"></i>
    </Button>
  </Col>

  {/* Input de Búsqueda */}
  <Col xs={12} sm={6} md={4} className="mb-2 mb-md-0 text-start">
    <input 
      type="text"
      className="form-control"
      placeholder="Buscar"
      value={filtering}
      onChange={e => setFiltering(e.target.value)}
    />
  </Col>

  {/* Badge de Objetos Desplegados alineado a la derecha */}
  <Col xs={12} sm={12} md={7} className="mb-2 mb-md-0 text-md-end text-start">
    <Badge bg="secondary">
      Objetos desplegados: {data ? data.length : 0}
    </Badge>
  </Col>
</Row>             
                <Row>
                    <Col xl={12}>
                        <Table className='mt-3' striped bordered hover responsive>
                            <thead>
                            {
                                table.getHeaderGroups().map(headerGroup => (
                                    <tr className='table-dark' key={headerGroup.id} >
                                        {
                                            headerGroup.headers.map( header => (                                                
                                                <th className='text-center' 
                                                key={header.id}
                                                onClick={header.column.getToggleSortingHandler()}
                                                >
                                                    {header.column.columnDef.header}
                                                    {
                                                        header.column.getIsSorted() ? (header.column.getIsSorted() == "asc" ? <i class="bi bi-arrow-up-short text-white"></i> : <i class="bi bi-arrow-down-short text-white"></i>) : null
                                                       
                                                    }
                                                    
                                                </th>
                                            ))
                                        }
                                    </tr>
                                ))
                            }                                                  
                            </thead>
                            <tbody>
                                {
                                    table.getRowModel().rows.map((row) => (
                                        <tr key={row.id}>
                                            {
                                                row.getVisibleCells().map((cell) => (
                                                    <td className='text-center'  key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                                                ))                                                                                                
                                            }
                                        </tr>
                                    ))
                                }
                              
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                        <li className={`page-item ${pagination.pageIndex === 0 ? 'disabled' : ''}`}>
                            <a className="page-link" onClick={() => table.setPageIndex(0)}>&laquo;</a>
                        </li>
                        <li className={`page-item ${pagination.pageIndex === 0 ? 'disabled' : ''}`}>
                            <a className="page-link" onClick={() => table.previousPage()}>Anterior</a>
                        </li>
                        <li className={`page-item ${pagination.pageIndex === totalPages - 1 ? 'disabled' : ''}`}>
                            <a className="page-link" onClick={() => table.nextPage()}>Siguiente</a>
                        </li>
                        <li className={`page-item ${pagination.pageIndex === totalPages - 1 ? 'disabled' : ''}`}>
                            <a className="page-link" onClick={() => table.setPageIndex(totalPages - 1)}>&raquo;</a>
                        </li>
                        <li className='page-item' >
                            <a className="page-link disabled"  >{pagination.pageIndex +1}/{totalPages}</a>  
                        </li>
                        </ul>
                    </nav>
                    </Col>
                </Row>
                </>
            )}
            
            <ItemDetailsModal 
                show={showDetails}
                handleClose={() => setShowDetails(false)}
                handleOpenModalLogs={handleOpenModalLogs}
                id={selectedId}
                token={selectedToken}
            />
            <ItemLogsModal 
                show={showLogs}
                handleClose={() => setShowLogs(false)}
                id={selectedId}
                handleBack={() => {
                    setShowLogs(false);
                    setShowDetails(true)
                }}
            />
            {/* <Reports data={data} categories={categories} /> */}
        </>
    );
}

export default Inventory;